import { useMemo } from "react";
import { FilterContexType } from "../components/layout/ViewHeader";
import { TransportPerspective } from "../state/preferences";

export const useTransportFilterContext = (transportsPerspective?: TransportPerspective): FilterContexType => {
	return useMemo(() => {
		if (transportsPerspective === "logical") {
			return ["trips", "entities"] as FilterContexType;
		}

		return ["trips"] as FilterContexType;
	}, [transportsPerspective]);
};
